var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.7493697 20.5398644-5.3690574-5.3689607c1.3345662-1.6048605 2.1385905-3.6656783 2.1385905-5.91113718 0-5.10585577-4.1537833-9.25976652-9.25939438-9.25976652-5.10572517 0-9.25950842 4.15391075-9.25950842 9.25976652 0 5.10551358 4.15378325 9.25908228 9.25950842 9.25908228 2.24533758 0 4.30626278-.8039129 5.91111798-2.1384834l5.3691714 5.3690747c.1669634.167078.3859317.2505599.604786.2505599.2188542 0 .4378225-.0834819.6048999-.2505599.3340407-.3340418.3340407-.8755339-.000114-1.2095757zm-20.03867977-11.28009788c0-4.16257828 3.38636775-7.54907104 7.54881849-7.54907104 4.16233668 0 7.54859038 3.38649276 7.54859038 7.54907104 0 4.16223618-3.3862537 7.54838678-7.54859038 7.54838678-4.16245074 0-7.54881849-3.3861506-7.54881849-7.54838678z"}));
}

SearchIcon.defaultProps = {"height":"22","viewBox":"0 0 22 22","width":"22"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
